import { createApp } from 'vue'

import * as Sentry from '@sentry/vue'
import ElTableInfiniteScroll from 'el-table-infinite-scroll'
import HighchartsVue from 'highcharts-vue'
// eslint-disable-next-line import/order
import 'highcharts/modules/accessibility'
import 'normalize.css/normalize.css'
import { createPinia } from 'pinia'

import 'element-plus/dist/index.css'

import { userManager, initializeUserManager } from '@/utils/auth/oidcClient'
import { registerIcons } from '@/utils/icons/registerIcons'
import { redactSensitive } from '@/utils/monitoring/redactSensitive'

import '@/assets/color.css'
import '@/assets/main.scss'
import '@/assets/tailwind.css'

import App from './App.vue'
import router from './router'

const app = createApp(App)

// 用 init 與否取代 enabled 選項：未啟用時連全域錯誤攔截與 fetch/XHR 包裝都不安裝
if (import.meta.env.VITE_SENTRY_DSN && ['staging', 'production'].includes(import.meta.env.MODE)) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: (integrations) => integrations.filter((integration) => integration.name !== 'BrowserSession'),
    beforeSend: (event) => {
      if (event.request?.data) {
        event.request.data = redactSensitive(event.request.data)
      }
      if (event.extra) {
        event.extra = redactSensitive(event.extra) as Record<string, unknown>
      }
      return event
    }
  })
}

const setup = async () => {
  registerIcons()

  const user = await userManager.getUser()
  if (user) {
    await initializeUserManager()
  }

  app.use(createPinia())
  app.use(router)
  app.use(HighchartsVue)
  app.use(ElTableInfiniteScroll)

  app.mount('#app')
}

setup()
